import Hero from '../components/Hero';
import About from '../components/About';
import Products from '../components/Products';
import Stats from '../components/Stats';
import WhyChooseUs from '../components/WhyChooseUs';
import Export from '../components/Export';
import Contact from '../components/Contact';
import Reveal from '../components/ui/Reveal';

export default function HomePage() {
  return (
    <>
      <Hero />
      <Reveal><About /></Reveal>
      <Reveal><Stats /></Reveal>
      <Reveal><Products /></Reveal>
      <Reveal><WhyChooseUs /></Reveal>
      <Reveal><Export /></Reveal>
      <Reveal><Contact /></Reveal>
    </>
  );
}
